import { render } from "./ProjectOverview.vue?vue&type=template&id=e106be4a&scoped=true"
import script from "./ProjectOverview.vue?vue&type=script&lang=js"
export * from "./ProjectOverview.vue?vue&type=script&lang=js"

import "./ProjectOverview.vue?vue&type=style&index=0&id=e106be4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e106be4a"]])

export default __exports__